'use client'

import LocalizationProvider from '../contexts/localization/Localization'
import { AppContextProvider } from '../contexts/AppContext'
import ActionCards from './ActionCards'
import languageDetector from '../utils/languageDetector'
import { ActionCardsProps } from '../store'
import { TooltipProvider } from '@playbooks/ui/components/tooltip'

function App({ ref, ...props }: ActionCardsProps) {
  return (
    <TooltipProvider>
      <AppContextProvider {...props}>
        <LocalizationProvider locale={languageDetector(props.settings?.locale as 'en' | 'de')}>
          <ActionCards ref={ref} />
        </LocalizationProvider>
      </AppContextProvider>
    </TooltipProvider>
  )
}

export default App
